import styled from 'styled-components';

import { Icon } from 'coreOld/elements';

export const Wrapper = styled.div`
  position: absolute;
  top: 22px;
  left: -10px;
  font-size: 12px;
`;

const EditIcon = () => {
  return (
    <Wrapper>
      <Icon name={Icon.PENCIL} hover />
    </Wrapper>
  );
};

export default EditIcon;
